module.exports = __webpack_public_path__ + "img/tec.59766bec.png";